import { Divider } from '@mui/material';
import { useUserThemeContext } from '@src/main/ui/providers/user/UserThemeContextProvider';
import { FC } from 'react';

const DrawerDivider: FC = () => {
  const { theme } = useUserThemeContext();
  return (
    <Divider
      sx={{
        ...(theme === 'Corporate' && {
          borderColor: 'white',
        }),
      }}
    />
  );
};

export default DrawerDivider;
